import React, { Dispatch, SetStateAction } from "react";
import { Grid, Box, InputAdornment } from "@mui/material";
import {
    StriimCheckbox,
    StriimControlLabel,
    StriimIconButton,
    StriimInputField,
    StriimTypography
} from "@striim/striim-ui";
import { Clear, Search } from "@mui/icons-material";
import { style } from "./select-schemas.styles";

interface SearchBarContainerProps {
    schemaType: string;
    searchQuery: string;
    setSearchQuery: Dispatch<SetStateAction<string>>;
    setFiltersDebounced: () => void;
    showSystemSchemas: boolean;
    isChecked: boolean;
    setIsChecked: Dispatch<SetStateAction<boolean>>;
}

const SearchBarContainer: React.FC<SearchBarContainerProps> = ({
    schemaType,
    searchQuery,
    setSearchQuery,
    setFiltersDebounced,
    showSystemSchemas,
    isChecked,
    setIsChecked
}) => {
    const formattedSchemaType = schemaType?.charAt(0).toLowerCase() + schemaType?.slice(1);
    return (
        <Grid container py={1} px={2} gap={2} justifyContent={"flex-end"}>
            {showSystemSchemas && (
                <StriimControlLabel
                    control={
                        <StriimCheckbox
                            checked={isChecked}
                            onClick={() => {
                                setIsChecked(!isChecked);
                                setFiltersDebounced();
                            }}
                        />
                    }
                    label={
                        <StriimTypography variant={"body4"} color={"greyscale.700"}>
                            Show system schemas
                        </StriimTypography>
                    }
                />
            )}
            <Box>
                <StriimInputField
                    sx={{ width: 300 }}
                    placeholder={`Search using ${schemaType ? formattedSchemaType : "schema"} name`}
                    value={searchQuery}
                    onChange={e => {
                        setSearchQuery(e);
                        setFiltersDebounced();
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search opacity={0.45} />
                            </InputAdornment>
                        ),
                        endAdornment: searchQuery ? (
                            <StriimIconButton
                                variant="primary"
                                sx={style.endAdornmentContainer}
                                onClick={() => {
                                    setSearchQuery("");
                                    setFiltersDebounced();
                                }}
                            >
                                <Clear sx={style.iconButton} />
                            </StriimIconButton>
                        ) : null,
                        "data-test-id": "search-schemas-input"
                    }}
                />
            </Box>
        </Grid>
    );
};

export default SearchBarContainer;
